// This file was autogenerated from /frontend/sail-next/packages/docs/src/component-examples/FormFieldGroup/invalid.story.tsx with go/sail-next-tailor-docs-publisher 

import * as React from 'react';
import { TextField, FormFieldGroup } from '@sail/ui';
export const Invalid = () => <FormFieldGroup legend="Full name" description="Enter your full name" invalid>
    <TextField label="First name" value="Tim" placeholder="First name" hiddenElements={['label']} />
    <TextField label="Last name" error="Last name missing" placeholder="Last name" hiddenElements={['label']} />
  </FormFieldGroup>;